import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts"

import { CustomTooltipWithFilterInfo } from "@/components/Analytics/analyticsChartCustomize"

import { AnalyticsChartProps, diagramColors } from "@/types/IAnalytics"

import { compactNumber } from "@/utils/formatNumber"


export const AnalyticsBarChart = (props: AnalyticsChartProps) => {
  const { data, dataKeys, colors, tooltipContent } = props

  return (
    <BarChart width={1400} height={600} data={data}>
       <XAxis dataKey="period" />
       <XAxis
        dataKey="filterText"
        xAxisId="altLabel-filterText"
        axisLine={false}
        tickLine={false}
        fontSize={12}
        interval={0}
      />
      <YAxis tickFormatter={compactNumber} />
      <Tooltip content={tooltipContent ?? CustomTooltipWithFilterInfo } />
      <Legend/>
      <CartesianGrid stroke="#f5f5f5"/>
      {
        dataKeys.map((data, index) => (
          <Bar
            key={index}
            minPointSize={1}
            dataKey={data.value}
            name={`${data.bigLabel}${data.optionsLabel ? `: ${data.optionsLabel}` : ""}`}
            fill={(colors ?? diagramColors)[index]}
            label={{ fill: "white" }}/>
        ))
      }
    </BarChart>
  )
}
